import Content from "../common/Content";
import Footer from "../common/Footer";
import Header from "../common/Header";
import DataTable from "react-data-table-component";
import { API } from "../../helper/Api";
import { useState, useEffect } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { RotatingLines } from "react-loader-spinner";
import SessionHandler from '../common/SessionHandler';
import { useRole } from "../contextApi/RoleContext";

export default function PurchaseOrders() {
  const [photos, setPhotos] = useState([]);
  const [items, setItems] = useState([]);
  const [mainData, setmainData] = useState([]);
  const [page, setPage] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [pending, setPending] = useState(true);
  const [saleDate, setsaleDate] = useState("");
  const { setRole, role, setPermission, permission, setUserDetails,userDetails} =
      useRole();

  useEffect(() => {
    purchaseOrderList();
  }, [page]);

  const purchaseOrderList = () => {
    setPending(true);

    API.getPurchaseOrder({ page })
      .then((datas) => {
        let filteredPurchase;
            let items1;
            if(userDetails.usertype !=="CORP"){
              filteredPurchase = datas.ApiDocument.Response.PurchaseOrders.filter(rec => 
                rec.PurchaseReceipts?.some(location => 
                  userDetails.storecode?.some(store => store.storecode === location.LocationIdentifier)
                )
              );
              items1 = filteredPurchase.flatMap(
                (PurchaseOrders) => PurchaseOrders
              );
              setTotalRecords(items1.length);
           
            }else{
              items1 = datas.ApiDocument.Response.PurchaseOrders.flatMap(
                (PurchaseOrders) => PurchaseOrders
              );
              setTotalRecords(datas.ApiDocument.TotalRecords);
            }
        // const items = datas.ApiDocument.Response.PurchaseOrders.flatMap(
        //   (PurchaseOrders) => PurchaseOrders
        // );
       
        //const itemIterate = datas.ApiDocument.Response.Styles.flatMap(mainStyle => mainStyle.StoreDescription);
        console.log("filtered_store",items1);
        setItems(items1);
        setPending(false);


      })
      .catch((err) => console.log(err));
  };


  useEffect(() => {
    if (items.length > 0) {
     return  API.DataTableScript();
    }
  }, [items]);

  // const usFormattedDate = new Date(isoDateString).toLocaleDateString('en-US');

  const nextButton = document.getElementById("pagination-next-page");

  const handleRowClicked = (row) => {
    // console.log("row", row);
    // console.log("row_id",totalRows);
    setPage(row);
    
  };
const dataSearch =() =>{
  alert("Hi");
}
  // const columns = [
  //   // { name: 'ID', selector: row => row.StyleNo, sortable: true },
  //   {
  //     name: "Order#",
  //     selector: (row) => row.PurchaseOrderNo,
  //     sortable: true,
  //   },
  //   { name: "Vendore", selector: (row) => row.VendorIdentifier, sortable: true },
  //   { name: "Ship To Location", selector: (row) => row.DefaultLocationIdentifier, sortable: true },

  //   {
  //     name: "Action",
  //     cell: (row) => (
  //       <a href="#" value={row.PurchaseOrderNo}>
  //         Edit
  //       </a>
  //     ),
  //     sortable: true,
  //   },
  //   // {
  //   //   name: "Price",
  //   //   selector: (row) => row.Items[0].BasePrice,
  //   //   sortable: true,
  //   // },
  //   // {
  //   //   name: "Action",
  //   //   cell: (row) => (
  //   //     <a href={`catalog-price-update?id=${row.StyleNo}`} value={row.StyleNo}>
  //   //       Edit
  //   //     </a>
  //   //   ),
  //   //   sortable: true,
  //   // },
  //   // Add more columns as needed
  // ];

  // const RenderData = () => {
    return (
      <>
      
            
            <div class="container-fluid page-body-wrapper">
          {/* <nav class="sidebar sidebar-offcanvas" id="sidebar">
            <ul class="nav">
            <li class="nav-item nav-category"></li>              
              <li class="nav-item">
                <a class="nav-link" href="/">
                  <span class="icon-bg"><i class="mdi mdi-home menu-icon"></i></span>
                  <span class="menu-title">Dashboard</span>
                </a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="employee">
                  <span class="icon-bg"><i class="mdi mdi-account-circle menu-icon"></i></span>
                  <span class="menu-title">Employees</span>
                </a>
              </li>               
              <li class="nav-item">
                <a class="nav-link" data-toggle="collapse" href="catalog-list" aria-expanded="false" aria-controls="ui-basic">
                  <span class="icon-bg"><i class="mdi mdi-crosshairs-gps menu-icon"></i></span>
                  <span class="menu-title">Products</span>
                </a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="web-orders">
                  <span class="icon-bg"><i class="mdi mdi-database menu-icon"></i></span>
                  <span class="menu-title">Web Orders</span>
                </a>
              </li>                                          
              <li class="nav-item">
                <a class="nav-link" href="purchase-orders">
                  <span class="icon-bg"><i class="mdi mdi-database menu-icon"></i></span>
                  <span class="menu-title">Purchase Orders</span>
                </a>
              </li>  
            
            </ul>
          </nav> */}


            <div class="main-panel">
        <div class="content-wrapper">
          {/* {pending ? (
            <div className="loader">
              <RotatingLines
                visible={true}
                height="96"
                width="96"
                strokeColor="grey"
                strokeWidth="2"
                animationDuration="0.75"
                ariaLabel="rotating-lines-loading"
                wrapperStyle={{}}
                wrapperClass=""
              />{" "}
            </div>
          ) : ( */}
            <div>
            {/* <form class="example" action="/action_page.php"> */}
              {/* <input type="text" placeholder="Search.." name="search2" />
              <button type="submit" onClick={dataSearch}><i class="fa fa-search"></i></button> */}
            {/* </form>  */}

             {/* <DataTable
                title="Purchase Orders"
                columns={columns}
                data={items}
                pagination
                paginationServer={true}
                // onChangeRowsPerPage={handleRowClicked}
                onChangePage={handleRowClicked}
                paginationTotalRows={totalRecords}
                paginationPerPage={10}
                progressPending={pending}

              /> */}

<div class="Card_contend">
            {pending ? (
              <div className="loader">
                <RotatingLines
                  visible={true}
                  height="96"
                  width="96"
                  strokeColor="grey"
                  strokeWidth="2"
                  animationDuration="0.75"
                  ariaLabel="rotating-lines-loading"
                />
              </div>
            ) : (
              <div>
                {!pending ? ( 
                  // <div style={{backgroundColor: "white",padding: "15px",marginTop: "10px"}}>
                  <table id="myTable1" className="row-border">           
                      <thead>
                        <tr>
                        <th style={{fontWeight:"bold",color: "#665d5d"}}>Order#</th>
                        <th style={{fontWeight:"bold",color: "#665d5d"}}>Vendore</th>
                        <th style={{fontWeight:"bold",color: "#665d5d"}}>Ship To Location</th>
                        </tr>
                      </thead>
                        <tbody>
                          {items.map((item, index) => (
                            <tr>
                              <td>{item.PurchaseOrderNo ? item.PurchaseOrderNo : ''}</td>
                              <td>{item.VendorIdentifier ? item.VendorIdentifier : ''}</td>
                              <td>{item.DefaultLocationIdentifier ? item.DefaultLocationIdentifier : ''}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                // </div>
                ): null} 
              </div>
            )}
            
            </div>




            </div>
          {/* )} */}
        </div>
      </div>


      </div>  

    
      </>
      
    );
  // };

  // return (
  //   <>
  //     {/* {photos.map((data) => (
  //           <h1>{data.id}</h1>
  //       ))} */}
  //     <Header />
  //     <Content data={RenderData} />
  //     <Footer />
  //   </>
  // );
}
